import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

function ViewEditDetails(props) {
  const history = useNavigate();

  const { userData } = props.state.auth;

  const loggedInRoleType = userData?.loggedInRoleType;

  const redirectRoute =
    loggedInRoleType === "CET"
      ? "CETDashboard"
      : loggedInRoleType === "RM"
      ? "RMDashboard"
      : "";

  return (
    <p
      style={{
        cursor: "pointer",
        color: "#00b1b1",
      }}
      onClick={() => {
        history(
          `/${redirectRoute}/edit-partner/${props.row?.original?.partnerFirmId}`
        );
      }}
      key={props.index}
    >
      {props?.block?.name === "VIEW_EDIT_DETAILS" && "View/Edit Details"}
    </p>
  );
}

const mapStateToProps = (state) => {
  return {
    state,
  };
};

export default connect(mapStateToProps)(ViewEditDetails);
